import { videoApi } from '@/api/index';

const state = {
    noDataMode: false,
    loadingShow: false,
    toggleLoadingShow: false,
    currentListData: [], // 当前选中tab下的所有数据
    loadPrev: '',
    loadNext: ''
};

const getters = {
    getVideoNoDataMode: state => state.noDataMode,
    getVideoLoadingShow: state => state.loadingShow,
    getCurrentVideoListData: state => state.currentListData, // 当前选中tab下的所有数据
    getVideoLoadPrev: state => state.loadPrev,
    getVideoLoadNext: state => state.loadNext,
    getToggleLoadingShow: state => state.toggleLoadingShow
};

const actions = {
    videoListApi ({ commit, state }, { urlApi, type }) {
        if (type === 2) {
            state.loadingShow = true;
        } else {
            state.toggleLoadingShow = true;
            state.currentListData = [];
        }
        return videoApi.getVideoList(urlApi).then(response => {
            commit('getVideoList', response);
        }, error => {
            commit('getVideoListFail');
            console.log('error', error);
        });
    }
};

const mutations = {
    showLoading (state, params) {
        state.loadingShow = params.isShow;
    },
    getVideoList (state, params) { // 请求video列表
        state.loadingShow = false;
        state.toggleLoadingShow = false;
        if (params.articles.length) {
            state.noDataMode = false;
            state.currentListData = [...state.currentListData, ...params.articles];
            if (!!params.next) {
                state.loadNext = params.next.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
            } else {
                state.loadNext = false;
            }
            state.loadPrev = params.prev.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
        } else {
            state.noDataMode = true;
            state.loadNext = false;
        }
    },
    getVideoListFail (state) {
        state.loadingShow = false;
        state.toggleLoadingShow = false;
        state.noDataMode = true;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/videoListStore.js